<template>
  <div class="container map">
    <!-- Map -->
    <gmap-map :center="map.center" :zoom="map.zoom" :options="map.options" ref="gmap" id="map">
    </gmap-map>
    <!-- start Navigation -->
    <div class="panel_center-top">
      <div class="map-button"
           v-on:click="toggleTraffic()"
           v-bind:class="{ 'map-button__active' : traffic.status }">
        <img src="../assets/img/map/trafic_off.svg" v-if="!traffic.status">
        <img src="../assets/img/map/trafic_on.svg" v-if="traffic.status">
      </div>
      <div class="map-button"
           v-on:click="toggleAllCars()"
           v-bind:class="{ 'map-button__active' : status.allCars }">
        <img src="../assets/img/map/show_car_off.svg" v-if="!status.allCars">
        <img src="../assets/img/map/show_car_on.svg" v-if="status.allCars">
      </div>
      <div class="map-button"
           v-on:click="toggleLastPath()"
           v-bind:class="{ 'map-button__active' : status.activeLast }">
        <img src="../assets/img/map/car_track_on.svg" v-if="status.activeLast">
        <img src="../assets/img/map/car_track_off.svg" v-else>
      </div>
    </div>
    <div class="panel_right-top">
      <div class="map-button" @click="toogleMapChoise">
        <img src="../assets/img/map/map_select.svg">
      </div>
			<div class="choise-map" v-if="showMapChoise">
				<div class="choise-map_item"
						 :class="{ 'active' : typeMap === 0 }"
						 @click="changeMapType(0)">
					<img src="../assets/img/map/osm-icon.png"/>
					<div>
						OSM
					</div>
				</div>
				<div class="choise-map_item"
						 :class="{ 'active' : typeMap === 1 }"
						 @click="changeMapType(1)">
					<img src="../assets/img/map/gmap-icon.png"/>
					<div>
						Google
					</div>
				</div>
			</div>
    </div>
    <div class="panel_right-center">
      <div class="map-button map-button"
        v-bind:class="{ 'map-button__active' : status.focus }"
        v-on:click="toggleFocus()">
        <img src="../assets/img/map/focus_car.svg" v-if="status.focus">
        <img src="../assets/img/map/focus_off.svg" v-else>
        <!--
        <img src="../assets/img/map/focus_user.svg">
        <img src="../assets/img/map/focus_car&user.svg">-->
      </div>
      <div class="map-button map-button_zoom-in"
           v-on:click="zoomIn()">
        <img src="../assets/img/map/zoom_in.svg"/>
      </div>
      <div class="map-button map-button_zoom-out"
           v-on:click="zoomOut()">
        <img src="../assets/img/map/zoom_out.svg"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../main'

  export default {
    name: 'google-map',
    data: function () {
      return {
        // Первичные настройки карты
        map: {
          center : {
            lat : 55.6507838,
            lng : 37.441247
          },
          options : {
            disableDefaultUI : true,
            gestureHandling: 'greedy'
          },
          zoom : 12,
        },

        // Точки маршрута
        way : {
          current : [],
          route   : [],
          last    : [],
          car     : [],
        },

        // Объекты карты
        markers : [
        ],
        markersAll : [
        ],
        markerList : [],

        plateAll : [],

        polylines : {
          main  :  '',
          bg    :  '',
          gap   :  '',
          day   :  {
            bg   : [],
            main : []
          }
        },
        icon : {
        },

        // Состояние
        status : {
          focus      : true,
          activeLast : true,
          allCars : false
        },

        // Пробки
        traffic : {
          layer   : '',
          status  : false,
          load    : 0
        },

				speedWay : {
          id : '',
					speeds : [],
					mapObjects : [],
					colors : {
            low : '#fd4741',
            medium : '#ffd000',
            high : '#009c52',
            veryhigh : '#0077c6',
            rampage : '#003366'
					},
					markers : [],
					infoWindow : [],
					lastInfoIndex : -1
        },

				networkTower : {
          Circles : [],
					Way : []
				},

        /*icon: {
          path: "M.412 27.65a.75.75 0 0 0 .971.985L12 23.946l10.59 4.69a.75.75 0 0 0 .97-.986L12.695.714a.75.75 0 0 0-1.384 0L.412 27.65z",
          //fillColor: '#40B59B',
          fillColor: '#50e3c2',
          fillOpacity: 1,
          strokeColor: '#000',
          strokeWeight: 2,
          strokeOpacity: .3,
          rotation: this.stateCar.course,
          anchor: new window.google.maps.Point(12, 14.5)
        }*/
      }
    },
    mounted(){
      this.unsubscribeAction = this.$store.subscribeAction({
        after: (action) => {
          if( action.type === 'changeHistoryDay' ){ // Выбор всех поездок за день
            this.changeHistoryDay();
          }
          if( action.type === 'journalRouteItem' ){ // Поменялся тип/активный элемент в журнале
            if( this.panelCar === 2 ){
              this.setJournal();
            }
          }
          if( action.type === 'journalEventItem' ){ // Поменялся тип/активный элемент в евентах
            if( this.panelCar === 2 ){
              this.setJournal();
						}
					}
        }
      });
      setTimeout( () => {
        if( this.currentId !== '' ){
          if( this.panelCar === 1 ){
            this.setManagment();
          }else if( this.panelCar === 2 ){
            if( this.historyDay === 'empty' ){
              this.setJournal();
            }else{
              this.setJournalDay( this.historyDay );
            }
          }
        }
			}, 300);
    },
    beforeDestroy() {
      this.unsubscribeAction();
    },
    computed : {
      currentId : function () {
        return this.$store.state.cars.current.id
      },
      lastState : function () {
        return this.$store.state.cars.lastSocket.state
      },
      lastRoute : function () {
        return this.$store.state.cars.lastSocket.route
      },
      stateCar : function(){
        return this.$store.state.cars.state[this.currentId]
      },
      routeCar : function(){
        return this.$store.state.cars.route[this.currentId]
      },
      journalStore : function () {
        return this.$store.state.journal
      },
      panelCar : function () {
        return this.$store.state.panels.car
      },
      plateList : function(){
        let plateList = {};

        for( let i = 0; i < this.$store.state.cars.list.length; i++ ){
          plateList[this.$store.state.cars.list[i].id] = this.$store.state.cars.list[i].registration_id;
        }

        return plateList;
      },
      historyDay: function () {
        return this.$store.state.map.historyDay
      },
      typeMap : function () {
        return this.$store.state.map.type
      },
      showMapChoise : function () {
        return this.$store.state.map.showChoise
      }
		},
    methods : {
      // Изменилось активное авто
      changeCar : function () {
        this.way.car     = [];
        this.way.current = [];
        this.way.route   = [];

        this.showAllCars();
        this.setManagment();
      },

      // Установки для Управления
      setManagment : function () {
        if( this.stateCar.is_in_route === true ){ // Если едем
          this.changeState();
          this.changeRoute();
        }else{                                    // Если стоим
          this.getLastWay();
          this.setCar();
        }
      },

      // Установки для Журнала
      setJournal : function (){
        this.clearMarkers();
        this.clearPolylines();

        if( this.journalStore.type === 0 ){ // Маршрут
          if( this.journalStore.menuItem.type === 0 ){ // Поездка

            HTTP.get('cars/' + this.currentId + '/routes/' + this.journalStore.menuItem.id + '/')
							.then( (response) => {
								if( response.data.speed[0] === null ){
								  if( response.data.coord_src === 2 || response.data.coord_src === 0 ){
										this.drawPointNetworkTower();
									}else{
                    this.drawSingleWay();
									}
								}else{
                  this.speedWay.speeds = response.data.speed;
                  this.drawSpeedWay();
								}
            	})
              .catch( () => {
                this.drawSingleWay();
                //this.$store.dispatch('errorResponse', error );
              })
            ;

          }else{ // Стоянка
            // Маркер стоянки
            this.markers.push( new window.google.maps.Marker({
              map : this.$refs.gmap.$mapObject,
              position: {
                lat: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
                lng: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
              },
              icon: require('../assets/img/map/stop-main.png'),
              zIndex : 10
            }));

            // Центрируем карту
            this.$refs.gmap.panTo({
              lat: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
              lng: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
            });
          }
        }else{ // Событие

					let icon;
					if(  this.journalStore.menuItem.id !== 205
            && this.journalStore.menuItem.id !== 226
            && this.journalStore.menuItem.id !== 218
            && this.journalStore.menuItem.id !== 219
            && this.journalStore.menuItem.id !== 200
            && this.journalStore.menuItem.id !== 271
            && this.journalStore.menuItem.id !== 267
            && this.journalStore.menuItem.id !== 222
            && this.journalStore.menuItem.id !== 213
            && this.journalStore.menuItem.id !== 215
            && this.journalStore.menuItem.id !== 216
            && this.journalStore.menuItem.id !== 214 ){
            icon = require('../assets/img/map/points/m' + this.journalStore.menuItem.id + '.svg')
					}else{
            icon = require('../assets/img/map/point.png')
					}

          this.markers.push( new window.google.maps.Marker({
            map : this.$refs.gmap.$mapObject,
            position: {
              lat: this.journalStore.menuItem.point[0],
              lng: this.journalStore.menuItem.point[1]
            },
            icon: icon
          }));

          this.$refs.gmap.panTo({
            lat: this.journalStore.menuItem.point[0],
            lng: this.journalStore.menuItem.point[1]
          });
        }
      },
      // Полный день
      setJournalDay : function ( listPoints ) {
        this.clearMarkers();
        this.clearPolylines();

        // Маркер откуда ехали
        this.markers.push( new window.google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: listPoints[0].listPoints[listPoints[0].listPoints.length-1].lat,
            lng: listPoints[0].listPoints[listPoints[0].listPoints.length-1].lng
          },
          icon: require('../assets/img/map/stop-other.png')
        }));
        // Маркер куда ехали
        this.markers.push( new window.google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: listPoints[listPoints.length-1].listPoints[0].lat,
            lng: listPoints[listPoints.length-1].listPoints[0].lng
          },
          icon: require('../assets/img/map/stop-other.png')
        }));

        let bounds = new window.google.maps.LatLngBounds();
        //
        for( let i = 0; i < listPoints.length; i++ ){
          if( listPoints[i].type === 1 ){
            if( i !== 0 && i !== listPoints.length-1 ){
              // Маркер промежуточный
              this.markers.push( new window.google.maps.Marker({
                map : this.$refs.gmap.$mapObject,
                position: {
                  lat: listPoints[i].listPoints[0].lat,
                  lng: listPoints[i].listPoints[0].lng
                },
                zIndex: 9,
                icon: require('../assets/img/map/stop-small.png')
              }));
            }
          }else{
            // Рисуем подложку маршрута
            this.polylines.day.bg.push( new window.google.maps.Polyline({
              path: listPoints[i].listPoints,
              geodesic: true,
              strokeColor: '#000000',
              strokeOpacity: 1.0,
              strokeWeight: 6.4
            }));
            // Рисуем маршрут
            this.polylines.day.main.push( new window.google.maps.Polyline({
              path: listPoints[i].listPoints,
              geodesic: true,
              strokeColor: '#1aad03',
              strokeOpacity: 1.0,
              strokeWeight: 6
            }));
            let j = this.polylines.day.main.length-1;

            this.polylines.day.bg[j].setMap( this.$refs.gmap.$mapObject );
            this.polylines.day.main[j].setMap( this.$refs.gmap.$mapObject );
          }

          for( let point in listPoints[i].listPoints ){
            bounds.extend( listPoints[i].listPoints[point] );
          }
        }

        // Вписываем область
        this.$refs.gmap.fitBounds( bounds );
      },

			// Отрисовка пути со скоростями
      drawSpeedWay : function(){
        let points = this.journalStore.menuItem.listPoints;
        let speeds = this.speedWay.speeds;
        let way = [{ points : [], speeds : [], type : '' }];

        // Рисуем подложку маршрута
        this.polylines.bg = new window.google.maps.Polyline({
          path: points,
          geodesic: true,
          strokeColor: '#000000',
          strokeOpacity: 1.0,
          strokeWeight: 6.4
        });
        this.polylines.bg.setMap( this.$refs.gmap.$mapObject );

        if( this.speedWay.infoWindow.length ){
          if( this.speedWay.lastInfoIndex !== -1  ){
            this.speedWay.infoWindow[this.speedWay.lastInfoIndex].close();
            this.speedWay.lastInfoIndex = -1;
          }
				}
        this.speedWay.infoWindow = [];

        function speedType( val ){
					if ( val > 10 && val <= 25) {
            return 'medium';
          } else if ( val > 25 && val <= 90) {
            return 'high';
          } else if ( val > 90 && val <= 130) {
            return 'veryhigh';
          } else if ( val > 130 ){
            return 'rampage';
          }else{
            return 'low';
					}
				}

        way[0].points.push( points[0] );
        way[0].speeds.push( speeds[0] );
        way[0].type = speedType( speeds[0] );


				for( let i = 1; i < points.length; i++ ){
				  let wL = way.length - 1;

          way[wL].points.push( points[i] );
          way[wL].speeds.push( speeds[i] );

          this.speedWay.infoWindow.push( new window.google.maps.InfoWindow() );

				  if( (speedType( speeds[i] ) !== way[wL].type) || i === points.length-1){

            // Рисуем маршрут
            this.speedWay.mapObjects.push( new window.google.maps.Polyline({
              path: way[wL].points,
              geodesic: true,
              strokeColor: this.speedWay.colors[way[wL].type],
              strokeOpacity: 1.0,
              strokeWeight: 6
            }) );
            this.speedWay.mapObjects[this.speedWay.mapObjects.length-1].setMap( this.$refs.gmap.$mapObject );


            // Показывание скорости на этой точке
            let p = way[way.length - 1].points;
            let s = way[way.length - 1].speeds;

            window.google.maps.event.addListener(this.speedWay.mapObjects[this.speedWay.mapObjects.length-1], 'click', (e) => {

              let a = p.map( (x, i) => {
                return {
                  lat : e.latLng.lat() - x.lat,
									lng : e.latLng.lng() - x.lng,
									index : i
								}
              });
              let b = a.sort((x, y) => {
                let xC = Math.sqrt( Math.abs( x.lat ) * Math.abs( x.lat ) +  Math.abs( x.lng ) * Math.abs( x.lng ) );
                let yC = Math.sqrt( Math.abs( y.lat ) * Math.abs( y.lat ) +  Math.abs( y.lng ) * Math.abs( y.lng ) );

                return xC - yC;
							})[0];
              let closestIndex = b.index;


              if( this.speedWay.lastInfoIndex !== -1  ){
                this.speedWay.infoWindow[this.speedWay.lastInfoIndex].close();
							}
              this.speedWay.lastInfoIndex = i;
              this.speedWay.infoWindow[i].setContent(
								'<div>Скорость: <b>' + JSON.stringify( s[closestIndex] ) + 'км/ч</b></div>');

              this.speedWay.infoWindow[i].setPosition(p[closestIndex]);
              this.speedWay.infoWindow[i].open(this.$refs.gmap.$mapObject);
            });

            window.google.maps.event.addListener(this.speedWay.mapObjects[this.speedWay.mapObjects.length-1], 'mouseover', () => {

              let pointsUnique = p.filter((e, i, a) =>
                i === a.findIndex( (j) => (
                  j.lat === e.lat && j.lng === e.lng
                ))
              );

              for (let i = 0; i < pointsUnique.length; i++ ) {
                this.speedWay.markers.push(
                  new window.google.maps.Marker({
                    position: pointsUnique[i],
                    map: this.$refs.gmap.$mapObject,
                    draggable: false,
                    clickable: false,
                    icon: {
                      path: "M-20,0 a20,20 0 1,0 40,0 a20,20 0 1,0 -40,0",
                      fillColor: '#000',
                      fillOpacity: .2,
                      anchor: new window.google.maps.Point(0,0),
                      strokeWeight: 0,
                      scale: 0.2
                    },
                    zIndex : 20
                  })
                );
              }
						});

            window.google.maps.event.addListener(this.speedWay.mapObjects[this.speedWay.mapObjects.length-1], 'mouseout', () => {
              for (let i = 0; i < this.speedWay.markers.length; i++ ) {
                this.speedWay.markers[i].setMap(null);
							}
              this.speedWay.markers = [];
						});


            way.push({ points : [], speeds : [], type : speedType( speeds[i] ) });
            wL = way.length - 1;

            way[wL].points.push( points[i] );
            way[wL].speeds.push( speeds[i] );
					}
				}


        // Маркер откуда ехали
        this.markers.push( new window.google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: this.journalStore.menuItem.listPoints[0].lat,
            lng: this.journalStore.menuItem.listPoints[0].lng
          },
          icon: require('../assets/img/map/pointA.png')
        }));
        // Маркер куда ехали
        this.markers.push( new window.google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
            lng: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
          },
          icon: require('../assets/img/map/pointB.png')
        }));

        // Вписываем область
        let bounds = new window.google.maps.LatLngBounds();
        for( let point in this.journalStore.menuItem.listPoints ){
          bounds.extend( this.journalStore.menuItem.listPoints[point] );
        }
        this.$refs.gmap.fitBounds( bounds );

			},
			// Отрисовка пути без скоростей
			drawSingleWay : function(){
        // Рисуем подложку маршрута
        this.polylines.bg = new window.google.maps.Polyline({
          path: this.journalStore.menuItem.listPoints,
          geodesic: true,
          strokeColor: '#000000',
          strokeOpacity: 1.0,
          strokeWeight: 6.4
        });
        // Рисуем маршрут
        this.polylines.main = new window.google.maps.Polyline({
          path: this.journalStore.menuItem.listPoints,
          geodesic: true,
          strokeColor: '#1aad03',
          strokeOpacity: 1.0,
          strokeWeight: 6
        });

        this.polylines.bg.setMap( this.$refs.gmap.$mapObject );
        this.polylines.main.setMap( this.$refs.gmap.$mapObject );

        // Маркер откуда ехали
        this.markers.push( new window.google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: this.journalStore.menuItem.listPoints[0].lat,
            lng: this.journalStore.menuItem.listPoints[0].lng
          },
          icon: require('../assets/img/map/pointA.png')
        }));
        // Маркер куда ехали
        this.markers.push( new window.google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lat,
            lng: this.journalStore.menuItem.listPoints[ this.journalStore.menuItem.listPoints.length-1 ].lng
          },
          icon: require('../assets/img/map/pointB.png')
        }));

        // Вписываем область
        let bounds = new window.google.maps.LatLngBounds();
        for( let point in this.journalStore.menuItem.listPoints ){
          bounds.extend( this.journalStore.menuItem.listPoints[point] );
        }
        this.$refs.gmap.fitBounds( bounds );
			},
			// Отрисовка точек по вышкам
			drawPointNetworkTower : function(){

        let b = this.journalStore.menuItem.listPoints;
        let pointsUnique = b.filter((e, i, a) =>
          i === a.findIndex( (j) => (
            j.lat === e.lat && j.lng === e.lng
          ))
        );

        for (let i = 0; i < pointsUnique.length; i++ ) {
					this.networkTower.Circles.push(
					  new window.google.maps.Circle({
							strokeColor: '#12d4f0',
							strokeWeight : 0,
							strokeOpacity: 0,
							fillColor: '#12d4f0',
							fillOpacity: 0.20,
							map: this.$refs.gmap.$mapObject,
							center: pointsUnique[i],
							radius: 400
						})
					);
        }

        this.polylines.main = new window.google.maps.Polyline({
          path: this.journalStore.menuItem.listPoints,
          strokeOpacity: 0,
          icons: [{
            icon: {
              path: 'M-1,0a1,1 0 1,0 2,0a1,1 0 1,0 -2,0',
              fillColor : '#12d4f0',
							fillOpacity: 1,
              strokeOpacity: 1,
              strokeColor: '#12d4f0',
              scale: 2
            },
            offset: '0',
            repeat: '20px'
          }]
        });
        this.polylines.main.setMap( this.$refs.gmap.$mapObject );


        let bounds = new window.google.maps.LatLngBounds();
        for( let point in pointsUnique ){
          bounds.extend( pointsUnique[point] );
        }
        this.$refs.gmap.fitBounds( bounds );
			},

      // Изменился state
      changeState : function () {
        const google = window.google;

        if( this.stateCar.is_in_route === true ){ // Если едем
          // собираем положения по state
          this.way.car.push({ lat: this.stateCar.lat, lng: this.stateCar.lng });

          // Очищаем маркеры
          this.clearMarkers();
          // Рисуем новый маркер
          this.markers.push( new google.maps.Marker({
            map : this.$refs.gmap.$mapObject,
            position: {
              lat: this.way.car[this.way.car.length-1].lat,
              lng: this.way.car[this.way.car.length-1].lng
            },
            icon: {
              path: "M.412 27.65a.75.75 0 0 0 .971.985L12 23.946l10.59 4.69a.75.75 0 0 0 .97-.986L12.695.714a.75.75 0 0 0-1.384 0L.412 27.65z",
              fillColor: '#000',
              fillOpacity: 1,
              strokeColor: '#000',
              strokeWeight: 2,
              strokeOpacity: .2,
              zIndex: 4,
              rotation: this.stateCar.course,
              anchor: new window.google.maps.Point(12, 14.5)
            },
            optimized: false,
            zIndex: 99,
          }));

          // Очищаем маршруты
          this.clearPolylines();
          // Рисуем и зазор маршрут
          if( this.status.activeLast ){
            // последний маршрут
            this.way.current = this.routeCar.tail;
            // Рисуем зазор
            this.polylines.gap = new window.google.maps.Polyline({
              path: this.way.car,
              geodesic: true,
              strokeColor: '#676767',
              strokeOpacity: 1.0,
              strokeWeight: 6.4,
              zIndex : 1
            });
            this.polylines.gap.setMap( this.$refs.gmap.$mapObject );
            // Рисуем подложку маршрута
            this.polylines.bg = new window.google.maps.Polyline({
              path: this.way.current,
              geodesic: true,
              strokeColor: '#000000',
              strokeOpacity: 1.0,
              strokeWeight: 6.4,
              zIndex : 2
            });
            this.polylines.bg.setMap( this.$refs.gmap.$mapObject );
            // Рисуем маршрут
            this.polylines.main = new window.google.maps.Polyline({
              path: this.way.current,
              geodesic: true,
              strokeColor: '#1aad03',
              strokeOpacity: 1.0,
              strokeWeight: 6,
              zIndex : 3
            });
            this.polylines.main.setMap( this.$refs.gmap.$mapObject );
          }

          // Центрируем карту
          if( this.status.focus === true ){
            this.$refs.gmap.$mapObject.setCenter({ lat: this.stateCar.lat, lng: this.stateCar.lng });
          }
        }else{  // Если стоим
          this.getLastWay();
          this.setCar();
        }

        if( this.status.allCars ){
          if( this.plateAll[this.currentId] ){
            this.plateAll[this.currentId].setMap(null);
            this.plateAll[this.currentId] = "";

            // Номера машин
            this.plateAll[this.currentId] = new google.maps.Marker({
              map: this.$refs.gmap.$mapObject,
              position: {
                lat: this.stateCar.lat,
                lng: this.stateCar.lng
              },
              icon: {
                path: "M 0 0 L 0 16 L 86 16 L 86 0 L 0 0 ",
                fillColor: '#fff',
                fillOpacity: 1,
                strokeColor: '#000',
                strokeWeight: 2,
                strokeOpacity: .2,
                labelOrigin: new google.maps.Point(42, 8),
                anchor: new google.maps.Point(42, -6)
              },
              label : this.plateList[this.currentId],
              optimized: false,
            });
          }
        }
      },
      // Изменился route
      changeRoute : function () {
        const google = window.google;

        if( this.status.activeLast ){
          // Стираем последние точки зазора
          this.way.car = [];
          // Собираем зазор
          this.way.car.push({ lat: this.way.current[this.way.current.length-1].lat, lng: this.way.current[this.way.current.length-1].lng });
          this.way.car.push({ lat: this.stateCar.lat, lng: this.stateCar.lng });

          // Очищаем маршруты
          this.clearPolylines();
          // последний маршрут
          this.way.current = this.routeCar.tail;
          // Рисуем зазор
          this.polylines.gap = new window.google.maps.Polyline({
            path: this.way.car,
            geodesic: true,
            strokeColor: '#676767',
            strokeOpacity: 1.0,
            strokeWeight: 6.4,
            zIndex : 1
          });
          this.polylines.gap.setMap( this.$refs.gmap.$mapObject );
          // Рисуем подложку маршрута
          this.polylines.bg = new window.google.maps.Polyline({
            path: this.way.current,
            geodesic: true,
            strokeColor: '#000000',
            strokeOpacity: 1.0,
            strokeWeight: 6.4,
            zIndex : 2
          });
          this.polylines.bg.setMap( this.$refs.gmap.$mapObject );
          // Рисуем маршрут
          this.polylines.main = new window.google.maps.Polyline({
            path: this.way.current,
            geodesic: true,
            strokeColor: '#1aad03',
            strokeOpacity: 1.0,
            strokeWeight: 6,
            zIndex : 3
          });
          this.polylines.main.setMap( this.$refs.gmap.$mapObject );
        }

        // Очищаем маркеры
        this.clearMarkers();
        // Рисуем новый маркер
        this.markers.push( new google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: this.way.car[this.way.car.length-1].lat,
            lng: this.way.car[this.way.car.length-1].lng
          },
          icon: {
            path: "M.412 27.65a.75.75 0 0 0 .971.985L12 23.946l10.59 4.69a.75.75 0 0 0 .97-.986L12.695.714a.75.75 0 0 0-1.384 0L.412 27.65z",
            fillColor: '#000',
            fillOpacity: 1,
            strokeColor: '#000',
            strokeWeight: 2,
            strokeOpacity: .2,
            zIndex: 4,
            rotation: this.stateCar.course,
            anchor: new window.google.maps.Point(12, 14.5)
          },
          optimized: false,
          zIndex: 99,
        }));

        // Центрируем карту
        if( this.status.focus === true ){
          this.$refs.gmap.$mapObject.setCenter({ lat: this.stateCar.lat, lng: this.stateCar.lng });
        }
      },

      // Устанавливаем маркер/маршрут текущей машины
      setCar : function(){
        const google = window.google;

        // Центрируем карту
        if( !this.status.allCars ){
          this.$refs.gmap.$mapObject.setCenter({ lat: this.stateCar.lat, lng: this.stateCar.lng });
        }

        // Очищаем маркеры
        this.clearMarkers();

        // Рисуем новый маркер
        if( this.stateCar.coord_src === 2  ){
          this.networkTower.Circles.push(
            new window.google.maps.Circle({
              strokeColor: '#12d4f0',
              strokeWeight : 0,
              strokeOpacity: 0,
              fillColor: '#12d4f0',
              fillOpacity: 0.20,
              map: this.$refs.gmap.$mapObject,
              center: {
                lat: this.stateCar.lat,
                lng: this.stateCar.lng
              },
              radius: 600
            })
          );
        }
        this.markers.push( new google.maps.Marker({
          map : this.$refs.gmap.$mapObject,
          position: {
            lat: this.stateCar.lat,
            lng: this.stateCar.lng
          },
          icon : {
						url: require('../assets/img/map/stop-main.png'),
            anchor: new window.google.maps.Point(12, 14.5)
          },
          zIndex : 99,
          optimized: false,
        }));
      },
      // Устанавливаем маркер не активной машины
      setOtherCar : function ( id, carData ) {
        const google = window.google;
        if( this.markerList[id] ){
          this.markerList[id].setMap(null);
          this.markerList[id] = ""
        }
        if( this.plateAll[id] ){
          this.plateAll[id].setMap(null);
          this.plateAll[id] = ""
        }

        if( carData.is_in_route ) { // В пути
          this.markerList[id] = new google.maps.Marker({
            map: this.$refs.gmap.$mapObject,
            position: {
              lat: carData.lat,
              lng: carData.lng
            },
            icon: {
              path: "M.412 27.65a.75.75 0 0 0 .971.985L12 23.946l10.59 4.69a.75.75 0 0 0 .97-.986L12.695.714a.75.75 0 0 0-1.384 0L.412 27.65z",
              fillColor: '#40B59B',
              fillOpacity: 1,
              strokeColor: '#000',
              strokeWeight: 2,
              strokeOpacity: .2,
              rotation: carData.course,
              anchor: new window.google.maps.Point(12, 14.5),
            },
            zIndex: 1,
            optimized: false,
          });
        }else{ // стоянка
          this.markerList[id] = new window.google.maps.Marker({
            map : this.$refs.gmap.$mapObject,
            position: {
              lat: carData.lat,
              lng: carData.lng
            },
            icon: {
              url : require('../assets/img/map/stop-other.png'),
            },
            zIndex: 1,
            optimized: false,
          });
        }

        // Номера машин
        this.plateAll[id] = new google.maps.Marker({
          map: this.$refs.gmap.$mapObject,
          position: {
            lat: carData.lat,
            lng: carData.lng
          },
          icon: {
            path: "M 0 0 L 0 16 L 86 16 L 86 0 L 0 0 ",
            fillColor: '#fff',
            fillOpacity: 1,
            strokeColor: '#000',
            strokeWeight: 2,
            strokeOpacity: .2,
            labelOrigin: new google.maps.Point(42, 8),
            anchor: new google.maps.Point(42, -6)
          },
          label : this.plateList[id],
          optimized: false,
        });


        this.plateAll[id].addListener('click', () => {
          this.$store.dispatch('markerMap', id);
        });
        this.markerList[id].addListener('click', () => {
          console.log( id );
          this.$store.dispatch('markerMap', id);
        });
      },

      // Получаем последний маршрут машины
      getLastWay : function () {
        if( this.status.activeLast ){
          // Очищаем маршрут
          this.clearPolylines();

          // Рисуем новый
          if( this.routeCar.tail.length ){
            this.way.last = this.routeCar.tail;

            // Рисуем подложку маршрута
            this.polylines.bg = new window.google.maps.Polyline({
              path: this.way.last,
              geodesic: true,
              strokeColor: '#000000',
              strokeOpacity: 1.0,
              strokeWeight: 6.4,
              zIndex : 2
            });
            this.polylines.bg.setMap( this.$refs.gmap.$mapObject );

            // Рисуем маршрут
            this.polylines.main = new window.google.maps.Polyline({
              path: this.way.last,
              geodesic: true,
              strokeColor: '#1aad03',
              strokeOpacity: 1.0,
              strokeWeight: 6,
              zIndex : 3
            });
            this.polylines.main.setMap( this.$refs.gmap.$mapObject );

            // Центрируем карту
            let bounds = new window.google.maps.LatLngBounds();
            for( let point in this.way.last ){
              bounds.extend( this.way.last[point] );
            }
            //this.$refs.gmap.fitBounds( bounds );
          }else{
            this.status.activeLast = false;
            this.getLastWay();
          }
        }else{
          this.clearPolylines();

          // Центрируем карту
          this.$refs.gmap.$mapObject.setCenter({ lat: this.stateCar.lat, lng: this.stateCar.lng });
          //this.$refs.gmap.$mapObject.setZoom(16);
        }
      },

      // Тугл всех машин на карте
      toggleAllCars : function () {
        this.status.allCars = this.status.allCars === false;

        if( this.status.allCars === true ){
          let markers = this.$store.state.cars.state;
          let positionMarkers = [];

          for( let item in markers ) {
            if (markers[item]) {
              positionMarkers.push({lat: markers[item].lat, lng: markers[item].lng});
            }
          }

          let bounds = new window.google.maps.LatLngBounds();
          for( let point in positionMarkers ){
            bounds.extend( positionMarkers[point] );
          }
          this.$refs.gmap.fitBounds( bounds );
        }

        this.showAllCars();
      },
      // Отрисовка всех машин на карте
      showAllCars : function () {
        const google = window.google;

        // Очищаем маркеры
        for( let key in this.markerList ){
          if( this.markerList[key] ){
            this.markerList[key].setMap(null);
            this.markerList[key] = ""
          }
          if( this.plateAll[key] ){
            this.plateAll[key].setMap(null);
            this.plateAll[key] = ""
          }
        }

        if( this.status.allCars === false ){
          // Центрируем карту
          this.$refs.gmap.$mapObject.setCenter({ lat: this.stateCar.lat, lng: this.stateCar.lng });
        }else{
          let markers = this.$store.state.cars.state;

          for( let item in markers ){
            // Сами машины
            if( !this.markerList[item] && markers[item] && parseInt(item) !== parseInt(this.currentId) ){
              if( markers[item].is_in_route ) { // В пути
                this.markerList[item] = new google.maps.Marker({
                  map: this.$refs.gmap.$mapObject,
                  position: {
                    lat: markers[item].lat,
                    lng: markers[item].lng
                  },
                  icon: {
                    path: "M.412 27.65a.75.75 0 0 0 .971.985L12 23.946l10.59 4.69a.75.75 0 0 0 .97-.986L12.695.714a.75.75 0 0 0-1.384 0L.412 27.65z",
                    fillColor: '#40B59B',
                    fillOpacity: 1,
                    strokeColor: '#000',
                    strokeWeight: 2,
                    strokeOpacity: .2,
                    rotation: markers[item].course,
                    anchor: new window.google.maps.Point(12, 14.5),
                  },
                  zIndex: 1,
                  optimized: false,
                });
              }else{ // стоянка
                this.markerList[item] = new window.google.maps.Marker({
                  map : this.$refs.gmap.$mapObject,
                  position: {
                    lat: markers[item].lat,
                    lng: markers[item].lng
                  },
                  icon: {
                    url : require('../assets/img/map/stop-other.png'),
                  },
                  zIndex: 1,
                  optimized: false,
                });
              }
              this.markerList[item].addListener('click', () => {
                this.$store.dispatch('markerMap', item);
              });
            }
            // Номера машин
            if( markers[item] ){
              this.plateAll[item] = new google.maps.Marker({
                map: this.$refs.gmap.$mapObject,
                position: {
                  lat: markers[item].lat,
                  lng: markers[item].lng
                },
                icon: {
                  path: "M 0 0 L 0 16 L 86 16 L 86 0 L 0 0 ",
                  fillColor: '#fff',
                  fillOpacity: 1,
                  strokeColor: '#000',
                  strokeWeight: 2,
                  strokeOpacity: .2,
                  labelOrigin: new google.maps.Point(42, 8),
                  anchor: new google.maps.Point(42, -2)
                },
                label : this.plateList[item],
                optimized: false,
              });

              this.plateAll[item].addListener('click', () => {
                this.$store.dispatch('markerMap', item);
              });
            }
          }
        }
      },


      // Очистка полилиний
      clearPolylines : function () {
        if( this.polylines.bg !== '' ){
          this.polylines.bg.setMap(null);
          this.polylines.bg = '';
        }
        if( this.polylines.main !== '' ) {
          this.polylines.main.setMap(null);
          this.polylines.main = '';
        }
        if( this.polylines.gap !== '' ) {
          this.polylines.gap.setMap(null);
          this.polylines.gap = '';
        }
        if( this.polylines.day.bg.length ){
          for( let i = 0; i < this.polylines.day.bg.length; i++ ){
            this.polylines.day.bg[i].setMap(null);
            this.polylines.day.main[i].setMap(null);
          }
          this.polylines.day.bg = [];
          this.polylines.day.main = [];
        }
        if( this.speedWay.mapObjects.length ){
          for( let i = 0; i < this.speedWay.mapObjects.length; i++ ){
            this.speedWay.mapObjects[i].setMap(null);
					}
          this.speedWay.mapObjects = [];
				}
				if( this.networkTower.Circles.length ){
          for( let i = 0; i < this.networkTower.Circles.length; i++ ){
            this.networkTower.Circles[i].setMap(null);
          }
          this.networkTower.Circles = [];
				}
        if( this.speedWay.infoWindow.length ){
          if( this.speedWay.lastInfoIndex !== -1  ){
            this.speedWay.infoWindow[this.speedWay.lastInfoIndex].close();
            this.speedWay.lastInfoIndex = -1;
          }
          this.speedWay.infoWindow = [];
        }
      },
      // Очистка маркеров
      clearMarkers : function () {
        for( let i = 0; i < this.markers.length; i++ ){
          this.markers[i].setMap(null);
        }
        this.markers = [];

        if( this.status.allCars === false ){
          for( let i = 0; i < this.markersAll.length; i++ ){
            this.markersAll[i].setMap(null);
          }
          this.markersAll = [];
        }
      },

      // Масштабирование карты
      zoomIn : function () {
        if( this.$refs.gmap.$mapObject.getZoom() < 21 ){
          this.$refs.gmap.$mapObject.setZoom( this.$refs.gmap.$mapObject.getZoom() + 1 );
        }
      },
      zoomOut : function () {
        if( this.$refs.gmap.$mapObject.getZoom() > 5 ){
          this.$refs.gmap.$mapObject.setZoom( this.$refs.gmap.$mapObject.getZoom() - 1 );
        }
      },

      // Пробки
      toggleTraffic : function () {
        if( this.traffic.load === 0 ){
          this.traffic.layer = new window.google.maps.TrafficLayer();
          this.traffic.load = 1;
        }
        if( this.traffic.status === false ){
          this.traffic.layer.setMap( this.$refs.gmap.$mapObject );
          this.traffic.status = true;
        }else{
          this.traffic.layer.setMap( null );
          this.traffic.status = false;
        }
      },

      // Тумблер последнего маршрута
      toggleLastPath : function () {
        // toggle Last Path
        this.status.activeLast = this.status.activeLast !== true;

        if( this.currentId !== '' && this.panelCar !== 2 ){
          this.getLastWay();
        }
      },
      toggleFocus : function () {
        if( this.status.focus === true ){
          this.status.focus = false;
        }else{
          this.$refs.gmap.$mapObject.setCenter({ lat: this.stateCar.lat, lng: this.stateCar.lng });
          this.status.focus = true;
        }
      },

      // Декодирование точек
      decodePoints : function ( points ) {
        let polyline = {};
        polyline.decode = function(str, precision) {
          var index = 0,
            lat = 0,
            lng = 0,
            coordinates = [],
            shift = 0,
            result = 0,
            byte = null,
            latitude_change,
            longitude_change,
            factor = Math.pow(10, precision || 6);

          while (index < str.length) {

            // Reset shift, result, and byte
            byte = null;
            shift = 0;
            result = 0;

            do {
              byte = str.charCodeAt(index++) - 63;
              result |= (byte & 0x1f) << shift;
              shift += 5;
            } while (byte >= 0x20);

            latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

            shift = result = 0;

            do {
              byte = str.charCodeAt(index++) - 63;
              result |= (byte & 0x1f) << shift;
              shift += 5;
            } while (byte >= 0x20);

            longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

            lat += latitude_change;
            lng += longitude_change;

            coordinates.push({ 'lat' : lat / factor, 'lng' : lng / factor });
          }

          return coordinates;
        };
        return polyline.decode( points );
      },


      // Отслеживаем изменение выбранного дня
      changeHistoryDay : function() {
        if( this.historyDay === 'empty' ){
          this.setJournal();
        }else{
          this.setJournalDay( this.historyDay );
        }
      },

      changeMapType : function ( type ) {
        this.$store.dispatch('changeMapType', type );
      },

      toogleMapChoise : function () {
        this.$store.dispatch('changeMapChoise');
      }
    },
    watch : {
      // Поменялась активная машина
      currentId : function() {
        if (this.currentId !== '' && this.stateCar && this.routeCar ) {
          this.changeCar();
        }
      },
      // Поменялся активный пункт меню авто
      panelCar : function () {
        this.clearMarkers();
        this.clearPolylines();
        // Строим под нужную вкладку
        if( this.panelCar === 1 ){       // Управление
          this.setManagment();
        }
      },
      'journalStore.menuItem' : function () {
      },

      // Поменялось состояние машины
      lastState : function ( newVal ) {
        if( this.panelCar === 1 ){
          if( this.currentId !== '' ){
            if( newVal.car_id === this.currentId ){
              this.changeState();
            }else{
              if( this.status.allCars ){
                this.setOtherCar( newVal.car_id, newVal.data );
              }
            }
          }else{
            if( this.status.allCars ){
              this.setOtherCar( newVal.car_id, newVal.data );
            }
          }
        }
      },
      lastRoute : function ( newVal ) {
        if( newVal.car_id === this.currentId ){
          if( this.panelCar === 1 && this.currentId !== '' ){
            this.changeRoute()
          }
        }
      },
    }
  }
</script>